import styled from 'styled-components';
import Theme from '../../Theme';

type Props = {
  variant: 'Header1' | 'Header2' | 'Header3' | 'Header4' | 'Header5' | 'Header6' | 'Header7' | 'Body1' | 'Body2' | 'Body3' | 'Cursor'
  color?: string
}

const Text = styled.p`
  margin:0;
  ${({ variant }: Props) => {
    switch (variant) {
      case 'Header1':
        return `
          font-weight: 700;
          font-size: 50px;
          line-height: 1.1;
          letter-spacing: 11px;
          @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
            font-style: normal;
            font-weight: bold;
            font-size: 22px;
            line-height: 22px;
            /* or 137% */
            letter-spacing: 6px;
          }
        `;
      case 'Header2':
        return `
          font-weight: 700;
          font-size: 28px;
          line-height: 40px;
          letter-spacing: 6px;
          @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
            font-style: normal;
            font-weight: bold;
            font-size: 20px;
            line-height: 22px;
            letter-spacing: 6px;
          }
        `;
      case 'Header3':
        return `
          font-weight: 700;
          font-size: 20px;
          line-height: 1;
          letter-spacing: 4px;
          @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
            font-style: normal;
            font-weight: bold;
            font-size: 18px;
            line-height: 22px;
            letter-spacing: 6px;
          }
        `;
      case 'Header4':
        return `
          font-weight: 700;
          font-size: 34px;
          line-height: 40px;
          letter-spacing: 6px;
          @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 6px;
          }
        `;
      case 'Header5':
        return `
          font-weight: 700;
          font-size: 20px;
          line-height: 40px;
          letter-spacing: 0.2px;
          @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 6px;
          }
        `;
      case 'Header6':
        return `
          font-weeight: 700;
          font-size: 18px;
          line-height: 1.111;
          letter-spacing: 4px;
          @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 6px;
          }
        `;
      case 'Header7':
        return `
          font-weight: 700;
          font-size: 40px;
          line-height: 1;
          letter-spacing: 6px;
          @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 6px;
          }
        `;
      case 'Body1':
        return `
          font-weight: 400;
          font-size: 16px;
          line-height: 1.5;
          letter-spacing: 0.3px;
          @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
            font-weight: normal;
            font-size: 16px;
            line-height: 120%;
            letter-spacing: 0.3px;
          }
        `;
      case 'Body2':
        return `
          font-weight: 400;
          font-size: 15px;
          line-height: 1.6;
          @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
            font-size: 16px;
            line-height: 120%;
            letter-spacing: 0.3px;
          }
        `;
      case 'Body3':
        return `
          font-weight: 400;
          font-size: 20px;
          line-height: 1.5;
          letter-spacing: 0.3px;
        `;
      case 'Cursor':
        return `
          font-weight: bold;
          font-size: 16px;
          letter-spacing: 2.5px;
          line-height: 1.375;
        `;
    }
  }}

  color: ${({ color }: Props) => color ? color : 'white'};
`;

export default Text;